<template>
  <div class="detect_create">
    <div class="detect_create_top">
      <div class="detect_create_top_message">
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title" style="width: 110px;">
            <span style="color: #FF0000;">*</span>
            清查单名称：
          </span>
          <el-input v-model="checkName" placeholder="请输入清查单名称" style="width: 520px;"></el-input>
        </div>
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title">
            <span style="color: #FF0000;">*</span>
            清查人名单：
          </span>
          <el-select v-model="checkUser" multiple placeholder="请选择清查人" style="width: 520px;" @change="checkUserChange">
            <el-option
              v-for="item in outAllUserList"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="detect_create_top_message">
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title" style="width: 110px;">
            <span style="color: #FF0000;">*</span>
            创建时间：
          </span>
          <el-date-picker
            v-model="startTime"
            type="date"
            placeholder="选择开始日期"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            style="width: 230px;">
          </el-date-picker>
          <span style="margin: 0 20px; line-height: 38px;">至</span>
          <el-date-picker
            v-model="endTime"
            type="date"
            placeholder="选择结束日期"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            style="width: 230px;">
          </el-date-picker>
        </div>
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title">
            <span style="color: #FF0000;">*</span>
            清查范围去除：
          </span>
          <el-select 
            v-model="checkPlace" 
            @change="checkPlaceChange"
            @remove-tag="clearPlace"
            multiple 
            placeholder="选择清查任务" 
            style="width: 520px;">
            <el-option
              v-for="item in placeList"
              :key="item.taskId"
              :label="item.taskName"
              :value="item.taskId">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="detect_create_top_message" style="padding-bottom: 30px;">
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title" style="width: 110px;">
            <span style="color: #F3F3F3;">*</span>
            清查备注：
          </span>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="textarea"
          style="width: 1000px;">
        </el-input>
        </div>
      </div>

      <div class="detect_create_top_message" style="padding-bottom: 30px;">
        <div class="detect_create_top_message_item">
          <span class="detect_create_top_message_item_title" style="width: 110px;">
            <span style="color: #FF0000;">*</span>
            分派子任务：
          </span>
          <el-table
            :data="outUserList"
            style="width: 1300px">
            <el-table-column
              type="index"
              width="100"
              label="序列">
            </el-table-column>
            <el-table-column
              prop="label"
              label="清查人"
              width="180">
            </el-table-column>
            <el-table-column
              label="清查子任务"
              prop="placeList">
              <template slot-scope="scope">
                <el-select 
                  v-model="scope.row.checkIdList" 
                  multiple 
                  placeholder="请分配清查任务" 
                  style="width: 520px;"
                  @change="checkPlaceIdSelectChange(scope.row)"
                  @remove-tag="clearPlace($event, scope.row)">
                  <el-option
                    v-for="item in placeList"
                    :key="item.taskId"
                    :label="item.taskName + '/数量'+ item.taskCount"
                    :value="item.taskId">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <el-button 
        type="primary"
        @click="submitDeteceData"
        style="height: 80px; width: 200px; font-size: 24px; margin: 60px 0 50px 1250px;">
        提交清查单
      </el-button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import { Loading } from 'element-ui';
  export default {
    name: 'DetectCreate',
    data() {
      return {
        checkName: '',
        outAllUserList: [],
        outUserList: [],
        checkUser: '',
        checkPlace: [],
        placeList: [],
        checkPlaceList: [],
        deleteId: '',
        startTime: '',
        endTime: '',
        textarea: '',
      }

    },

    methods: {
      //获取清查人员
      getOutUserList() {
        let params = {
          userName: this.checkUser,
        }
        this.axios({
          method: 'GET',
          url: '/public/getOutUsers',
          params:params,
        }).then((res)=>{
          if(res.data.code == 200) {
            this.outAllUserList = res.data.data
            this.outUserList = this.outAllUserList
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      //获取清查任务区域
      getSortByPlace(index, idList) {
        let ids = [].concat(this.checkPlace)
        //如果子任务选择框进行了选择
        if(idList != undefined) {
          ids.push(idList)
        }
        let originIds = [].concat(this.deleteId)
        this.axios({
          method: 'GET',
          url: '/detect/sortByPlace',
          params: {
            ids: ids + '',
            originIds: originIds + '' 
          },
        }).then((res)=>{
          if(res.data.code == 200) {
            this.placeList = res.data.data
            //调用对表格渲染数据改造的方法
            this.changeUserList(res.data.data, index)
            this.deleteId = ''
          } else {
            this.$message.error(res.data.message)
          }
        })
      },

      //改造清查人数组
      changeUserList(placeList, index) {
        // console.log(index)
        if(index === undefined) {
          if(this.outUserList[0] !== undefined) {
            let add1 = {placeList: placeList}
            let add2 = {checkIdList: []}
            let add3 = {taskNum: 0}
            let add4 = {index: 0}
            this.outUserList.forEach(item => {
              add4.index += 1
              Object.assign(item, add1, add2, add3, add4)
            })
            // console.log(this.outUserList)
          }
        } else {
          
        }
      },

      //筛选清查人员
      getOutUserSearchList() {
        // let authorization = Cookies.get("Authorization");
        let ids = [].concat(this.checkUser)
        this.axios({
          method: 'GET',
          url: '/public/showOut',
          params: {
            ids: ids + ''
          },
        }).then((res)=>{
          console.log(res)
          if(res.data.code == 200) {
            this.outUserList = res.data.data
            this.getSortByPlace()
          } else {
            this.$message.error(res.data.message)
          }
        })
      },

      //清查人名单发生变化
      checkUserChange() {
        this.getOutUserSearchList()
      },
      //清查范围发生变换
      checkPlaceChange() {
        // console.log(e,i)
        this.getSortByPlace()
      },

      clearPlace(e, scope) {
        console.log(e, scope)
        this.deleteId = e
        // this.getSortByPlace()
        if(scope != undefined) {
          
          this.getSortByPlace(scope.index, scope.checkIdList)
        } else {
          this.getSortByPlace()     
        }
      },

      //选择框id发生变化时
      checkPlaceIdSelectChange(scope) {
        console.log(scope)
        // this.checkPlace.push(scope.checkIdList)
        console.log(this.outUserList)
        this.getSortByPlace(scope.index, scope.checkIdList)
      },

      //提交清查任务
      submitDeteceData() {
        let submitData = {
          detect: {
            detectName: this.checkName,
            predictDate: this.endTime,
            msg: this.textarea,
          },
          taskList: [],
        }
        this.outUserList.forEach(item => {
          console.log(item)
          let pushData = {
            userId: item.id,
            tasks: item.checkIdList
          }
          submitData.taskList.push(pushData)
        })
        let loadingInstance = Loading.service({
          lock: 'loading',
          text:'提交中请稍后....'
        });
        this.axios({
          method: 'POST',
          url: '/detect/creatTask',
          data: submitData,
          Headers: {
            'Content-Type':'application/json;charset=UTF-8'
          },
        }).then(res => {
          console.log(res)
          if(res.data.code == 200) {
            this.$message.success('创建清查任务成功')
            this.$nextTick(() => { 
              loadingInstance.close();
            });
          } else {
            this.$message.error(res.data.message)
            this.$nextTick(() => { 
              loadingInstance.close();
            });
          }
        })
      },
    },

    created() {      
      this.getOutUserList()
      this.getSortByPlace()
    }
  }
</script>

<style lang="less" >
  .detect_create {
    background-color: #F3F3F3;
    border: 10px #fff solid;

    .detect_create_top {
      display: flex;
      flex-direction: column;

      .detect_create_top_message {
        display: flex;
        justify-content: start;
        margin: 10px 0 0 30px;

        .detect_create_top_message_item {
          margin: 30px 80px 0 0;
          display: flex;
          justify-content: start;

          .detect_create_top_message_item_title {
            line-height: 38px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Detect/DetectCreate.vue